<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
          <BreadcrumbItem to="/host/index/ex/list">展商管理</BreadcrumbItem>
          <BreadcrumbItem>添加展商</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">添加展商</div>
      </div>
      <div class="f-tar" style="padding-top: 37px;">
        <Button @click="$router.push('/host/index/ex/list')">返回</Button>
      </div>
    </div>
    <div class="layout-content">
      <!-- .company-info-basic .cib -->
      <div class="cib">
        <Row>
          <Col span="12">
          <div class="cib-l">
            <div class="cib-form">
              <Form ref="form" :model="form" :rules="ruleInline" label-position="right" :label-width="120" @submit.native.prevent>
                <FormItem label="公司全称：" prop="CompName">
                  <Input type="text" v-model="form.CompName" placeholder="请输入公司全称" />
                </FormItem>
                <FormItem label="公司简称：" prop="ShortName">
                  <Input type="text" v-model="form.ShortName" placeholder="请输入公司简称" />
                </FormItem>
                <FormItem label="公司英文名：" prop="CompNameEn">
                  <Input type="text" v-model="form.CompNameEn" placeholder="请输入公司英文名" />
                </FormItem>
                <FormItem label="联系人：" prop="NikeName">
                  <Input type="text" v-model="form.NikeName" placeholder="请输入联系人" />
                </FormItem>

                <FormItem label="手机：">
                  <Input type="text" v-model="form.mobile" placeholder="请输入手机" />
                </FormItem>
                <FormItem label="账号：" prop="name">
                  <Input type="text" v-model="form.name" placeholder="请输入账号" />
                </FormItem>
                <FormItem label="密码：" prop="password">
                  <Input type="password" v-model="form.password" placeholder="请输入密码" />
                </FormItem>

                <!-- <FormItem label="展品类别：" prop="type" :required="true">
                  {{form.type}}
                  <categoryFiled v-model="form.type" ref="categoryFiled"></categoryFiled>
                </FormItem> -->

                <FormItem label="展品类别：" prop="category" :required="true" v-if="type">
                  <Cascader change-on-select v-model="form.category" :data="type" filterable @on-change="changeCategory" placeholder="输入关键词进行类别搜索"></Cascader>
                </FormItem>

                <Row v-for="(booth, index) in form.boothInfo" :key="'boothInfo-' + index">
                  <Col span="11">
                  <FormItem label="展馆编号：">
                    <Select v-model="booth.Hall" filterable>
                      <Option v-for="item in exHallArr" :value="item.name" :key="item.name">{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                  </Col>
                  <Col span="11">
                  <FormItem label="展位编号：" prop="time">
                    <Input v-model="booth.Code" />
                  </FormItem>
                  </Col>
                  <Col span="2" class="ie-icon">
                  <Icon type="ios-add-circle-outline" v-if="index === 0" @click="addBootArr()" />
                  <Icon type="ios-remove-circle-outline" v-else style="color: red;" @click="delBootArr(index)" />
                  </Col>
                </Row>

                <FormItem label="所在省市：" style="margin-bottom: 0;">
                  <Row type="flex" justify="space-between">
                    <Col span="11">
                    <FormItem prop="province">
                      <Select v-model="form.Province" placeholder="请选择省份" @on-change="changeProvince">
                        <Option v-for="(item, index) in provinceArr" :key="item.value" :value="item.value">{{ item.label }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                    <Col span="11">
                    <FormItem prop="city">
                      <Select v-model="form.City" placeholder="请选择城市" @on-change="changeCity">
                        <Option v-for="(item, index) in citiesArr" :key="item.value" :value="item.value">{{ item.label }}</Option>
                      </Select>
                    </FormItem>
                    </Col>
                  </Row>
                </FormItem>
                <FormItem label="地址：" prop="address">
                  <Input type="text" v-model="form.Address" placeholder="请输入详细地址" />
                </FormItem>
                <FormItem>
                  <Button type="primary" size="large" @click="mySubmit('form')" style="width: 154px;">保存</Button>
                </FormItem>
              </Form>
            </div>
          </div>
          </Col>
          <Col span="12">
          <div class="cib-r">
            <Form label-position="right" :label-width="120" @submit.native.prevent>
              <FormItem label="公司logo：">
                <div class="logo-example">
                  <template v-if="uploadList && uploadList.length">
                    <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index" style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;">
                      <template v-if="item.status === 'finished'">
                        <img :src="item.url" style="width: 150px;height: 150px;" v-if="item.url" />
                        <template v-else>
                          <img src="@assets/img/company-default-logo.png" style="width: 150px;height: 150px;" />
                        </template>
                        <div class="my-upload-list-cover">
                          <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        </div>
                      </template>
                      <template v-else>
                        <Spin v-if="item.showProgress" style="width: 150px;height: 150px;">
                          <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                        </Spin>
                      </template>
                    </div>
                  </template>

                  <div class="my-upload-list" style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;" v-else>
                    <template>
                      <!-- <img
                          src="@assets/img/company-default-logo.png"
                          style="width: 150px;height: 150px;"
                        /> -->
                    </template>
                  </div>
                  <div class="logo-example-box">
                    <div class="logo-example-item z-large-s">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <div v-else style="width:40px;height:40px;border: 1px solid #bfbfbf;"></div>
                      <!-- <img src="@assets/img/company-default-logo.png" v-else /> -->
                      <p>图片尺寸：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-m">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <div v-else style="width:30px;height:30px;border: 1px solid #bfbfbf;"></div>
                      <!-- <img src="@assets/img/company-default-logo.png" v-else /> -->
                      <p>图片尺寸：120*120px</p>
                    </div>
                    <div class="logo-example-item z-large-l">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <div v-else style="width:20px;height:20px;border: 1px solid #bfbfbf;"></div>
                      <!-- <img src="@assets/img/company-default-logo.png" v-else /> -->
                      <p>图片尺寸：30*30px</p>
                    </div>
                  </div>
                </div>
                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :format="['jpg','jpeg','png']" :max-size="2048" :headers="formHeaders" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :action="uploadUrl" style="display: inline-block;position: relative;">
                  <Button icon="ios-cloud-upload-outline">更改Logo</Button>
                  <div style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;"></div>
                </Upload>
                <p class="upload-p">(图片要求：2M以下的jpg或png，建议尺寸120*120px)</p>
              </FormItem>
            </Form>
          </div>
          </Col>
        </Row>
        <!-- 图片查看 -->
        <iModal title="图片查看" cancel-text v-model="visible">
          <div style="text-align: center;">
            <img :src="imgName" v-if="visible" style="max-width: 100%" />
          </div>
        </iModal>
      </div>
    </div>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { provinces } from "@/other/provinces";
import { mapGetters, mapMutations, mapActions } from "vuex";
import categoryFiled2 from "@components/category-filed/category-filed.vue";
import categoryFiled from "@components/category-filed-bygroupId/category-filed-bygroupId.vue";

export default {
  name: "ex-add",
  data () {
    const that = this;

    const categoryValid = (rule, value, callback) => {
      if (value && value.length) {
        callback();
      } else {
        callback(new Error("请选择产品类别"));
      }
    };

    return {
      type: [],
      CategoryData: null,
      categoryFiled2type: [],
      loading: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      commonType: 2,
      Introduction: [],
      provinceArr: [],
      citiesArr: [],
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      form: {
        // form双向绑定
        name: "", // 用户名
        NikeName: "", // 联系人
        CompName: "", // 公司名
        CompNameEn: "", // 公司英文名
        ShortName: "", // 简称
        Address: "", // 地址
        Country: "",
        Province: "",
        City: "",
        mobile: "", // 手机
        password: "", // 密码

        category: [], // 展品分类 
        boothInfo: [{ Hall: "", Code: "" }]
      },

      exHallArr: [],
      exTypeArr: [], // 展商类别
      ruleInline: {
        // 效验规则
        CompName: [
          { required: true, message: "公司全称不能为空", trigger: "blur" },
          {
            type: "string",
            min: 3,
            message: "公司全称不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "公司全称不能大于50位",
            trigger: "blur"
          }
        ],
        category: [
          {
            validator: categoryValid,
            trigger: "change",
          },
        ],
        NikeName: [
          { required: true, message: "联系人不能为空", trigger: "blur" }
        ],
        ShortName: [
          { required: true, message: "公司简称不能为空", trigger: "blur" }
        ],
        Address: [
          { required: true, message: "公司地址不能为空", trigger: "blur" }
        ],
        Province: [
          {
            required: true,
            message: "请选择所在的省份",
            trigger: "change"
          }
        ],
        City: [
          { required: true, message: "请选择所在的城市", trigger: "change" }
        ],
        type: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("展品类别为必填选项");
              } else if (value.length) {
                callback();
              } else {
                callback("展品类别为必填选项");
              }
            },
            trigger: "blur"
          }
        ],

        name: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("用户名为必填选项");
              } else if (/^[a-zA-Z0-9_-]{4,16}$/.test(value)) {
                callback();
              } else {
                callback("用户名为4到16位（字母，数字，下划线，减号）");
              }
            },
            trigger: "blur"
          }
        ],
        mobile: validator.phone,
        password: validator.password
      },
      visible: false,
      defaultList: [],

      uploadList: [],

      coverImg: "",
      uploadVideoFlag: false,
      AgentId: "cd4e8cef-c6f7-4e72-9132-93161b9e8c43"
    };
  },
  components: {
    categoryFiled,
    categoryFiled2,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      hostExhibition: "hostSetModule/getHostExhibition",
    }),
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created () {
    this.provinceArr = provinces.data;
    this.init();
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex",
      setCompany: "loginModule/setCompany"
    }),
    ...mapActions({
      getCompany: "loginModule/getCompany",
      editCompany: "companyModule/editCompany",
      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData",
      // 用户注册
      getMsgCode: "loginModule/getMsgCode",
      registerExhibition: "registerModule/registerExhibition",

      getHallByExhibition: "exhibitionModule/getHallByExhibition",
      getCategoryByExhibition: "exhibitionModule/getCategoryByExhibition",
      getCategoryByExhibitionList: "exhibitionModule/getCategoryByExhibitionList",

      getProductByGroupId: "categoryModule/getProductByGroupId", // 根据展会Id获取产品类别

      RegisterAccount: "hostSetModule/RegisterAccount", // 添加用户
      RegisterCompany: "hostSetModule/RegisterCompany", // 添加公司
      RegisterJoin: "hostSetModule/RegisterJoin", // 添加参展
      RegisterStaff: "hostSetModule/RegisterStaff" // 添加员工
    }),
    async init () {
      let hallData = await this.getHallByExhibition(this.exhibitionInfo.id);
      if (hallData && hallData.length) {
        this.exHallArr = hallData;
      } else {
        this.exHallArr = [];
      }

      let categoryData = await this.getProductByGroupId({
        groupId: this.exhibitionInfo.groupId,
        level: 0,
        loadChild: true,
      }); // 暂时先写死了值
      if (categoryData && categoryData.length) {
        categoryData.map((c) => {
          // c.value = c.id;
          c.value = c.name;
          c.label = c.name;
          c.children = JSON.parse(JSON.stringify(c.list));
          c.children.map((v) => {
            v.value = v.name;
            v.label = v.name;
            v.children = JSON.parse(JSON.stringify(v.list));
            v.children.map((z) => {
              z.value = z.id;
              z.value = z.name;
              z.label = z.name;
              z.children = JSON.parse(JSON.stringify(z.list));
            });
          });
        });
        this.type = categoryData;
      } else {
        this.type = [];
      }
    },
    async mySubmit (name) {
      let form = this.form;
      let valid = await this.validForm(name);
      if (!valid) return;
      let logo = "";
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      }
      // logo不是必填
      // else {
      //   this.$Message.error("请上传公司logo");
      //   return;
      // }
      if (form.mobile && /^[1][0-9]{10}$/.test(form.mobile) === false) {
        this.$Message.error("请输入正确的手机号码");
        return;
      }
      let registerReq = {
        // 注册请求opt
        UserName: form.name,
        Password: form.password,
        ConfirmPassword: form.password,
        Name: form.CompName,
        NikeName: form.NikeName
      };
      console.log("registerReq: ", registerReq);
      let user = null;
      let data = await this.RegisterAccount(registerReq); // 注册用户
      if (data && data.info) {
        // 注册成功有用户信息
        user = data.info;
      } else {
        this.$Message.error(data.errors[0].description);
        return;
      }

      let companyReq = {
        // 公司请求opt
        UserId: user.id,
        AgentId: this.AgentId,
        Logo: logo,
        CompName: form.CompName,
        ShortName: form.ShortName,
        CompNameEn: form.CompNameEn,
        Country: form.Country,
        Province: form.Province,
        City: form.City,
        Address: form.Address,
        Name: form.NikeName
      };
      console.log("companyReq: ", companyReq);
      let company = null;
      let data2 = await this.RegisterCompany(companyReq); // 注册公司
      if (data2 && data2.info) {
        company = data2.info;
      } else {
        this.$Message.error(data2.errors[0].description);
        return;
      }
      this.CategoryData = this.changeCategory();
      let joinReq = {
        // 参展请求opt
        CompId: company.compId,
        ExhibitionId: this.exhibitionInfo.id,
        ExHall: "",
        Categories: this.CategoryData,
        BoothInfo: form.boothInfo
      };
      console.log("joinReq: ", joinReq);
      let join = null;
      let data3 = await this.RegisterJoin(joinReq); // 加入展会
      if (data3 && data3.info) {
        join = data3.info;
      } else {
        this.$Message.error(data3.errors[0].description);
        return;
      }
      this.$Message.success("保存成功!");
      setTimeout(() => {
        this.$router.push("/host/index/ex/list");
      }, 400);
    },

    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 上传图片
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    handleSuccess (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片"
      });
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片"
      });
    },
    handleBeforeUpload () {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`
        });
      }
      return check;
    },
    changeProvince (val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (val == this.provinceArr[i].value) {
          this.citiesArr = this.provinceArr[i].children;
          this.countyArr = [];
        }
      }
    },
    changeCity (val) {
      for (var i = 0; i < this.citiesArr.length; i++) {
        if (val == this.citiesArr[i].value) {
          this.countyArr = this.citiesArr[i].children;
        }
      }
    },
    selectChange (e) {
      if (e && e.length > 3) {
        this.form.type = [e[0], e[1], e[2]];
      }
    },
    addBootArr () {
      this.form.boothInfo.push({ Hall: "", Code: "" });
    },
    delBootArr (i) {
      this.form.boothInfo.splice(i, 1);
    },

    changeCategory (val) {
      let category = this.form.category;
      if (val) {
        category = this.form.category = val;
      }
      console.log('category', category);
      console.log('type', this.type);
      let data = null;
      this.type.forEach((c) => {
        if (category[0] && c.name === category[0]) {
          data = JSON.parse(JSON.stringify(c));
          data.list = [];
          delete data.children;
          if (c.list && c.list.length && category[1]) {
            c.list.forEach((v) => {
              if (v.name === category[1]) {
                data.list[0] = JSON.parse(JSON.stringify(v));
                data.list[0].list = [];
                delete data.list[0].children;
                if (v.list && v.list.length && category[2]) {
                  v.list.forEach((j) => {
                    if (j.name === category[2]) {
                      data.list[0].list[0] = JSON.parse(JSON.stringify(j));
                      delete data.list[0].list[0].children;
                    }
                  });
                }
              }
            });
          }
        }
      });
      console.log('changeCategory', data);
      return data ? [data] : [];
    },
  }
};
</script>

<style scoped lang="scss">
.ie-icon {
  line-height: 31px;
  padding-left: 30px;
  .ivu-icon {
    font-size: 22px;
    cursor: pointer;
    font-size: 22px;
    color: #118eea;
  }
  &.z-remove {
    color: #d71f06;
  }
}
.addcase {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 900px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
</style>
